import { memo, FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { clx } from 'Utils';
import { Colors } from 'Types';
import { Button, FontAwesome } from 'Elements';
import styles from 'partials/job/filters/job-selected-filter.module.scss';

interface Props {
	filterName: ReactNode;
	onRemove: () => void;
}

export const JobSelectedFilterItem: FC<Props> = memo(
	({ filterName, onRemove }) => {
		const { t } = useTranslation();
		return (
			<div
				role="button"
				className={clx(
					'd-inline-flex justify-content-center align-items-center gap-2',
					styles.badge
				)}>
				<span className="flex-grow-1">{filterName}</span>
				<Button
					title={t('button.remove')}
					color={Colors.empty}
					className="p-0"
					onClick={onRemove}>
					<FontAwesome size="sm" icon="xmark" />
				</Button>
			</div>
		);
	}
);

JobSelectedFilterItem.displayName = 'JobSelectedFilterItem';
